import { CmsOfferPackage } from '../CmsOfferPackage';

export abstract class OfferBaseData {
  name?: string;

  startDate?: string;

  endDate?: string;

  offsetDays: number;

  priority?: number;

  abstract get packages(): CmsOfferPackage[];
}
